import * as React from 'react';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import {ClickAwayListener} from '@mui/material'
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { useNavigate } from 'react-router-dom';

interface iData {
    name:string,link:string,
    icon?:React.ReactElement,
    onClick:()=>void
}
interface iProps {
    data:iData[],
    handleClick:(e:any)=>void,
    anchorEl:null | HTMLElement,
    setAnchorEl:(e:null | HTMLElement)=>void,
    
}
 export const   DropDownMenu=React.forwardRef(({data,handleClick,anchorEl,setAnchorEl}:iProps,ref:any )=> {


    const navigate=useNavigate()
 
    const handleClose = (link:string,onClick?:any) => {
      onClick()
       setAnchorEl(null)
     
    };
    const handleClickAway=()=>{
      setAnchorEl(null)
    }
   
  return (

    <Menu
    id="basic-menu"
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClick={(e:React.MouseEvent)=>setAnchorEl(null)}
    ref={ref}
    onClose={handleClose}
  
    MenuListProps={{
      'aria-labelledby': 'basic-button',
    }}
    
  >
    {
        data.map((ele,index)=>
            <MenuItem key={index} onClick={()=>handleClose(ele.link,ele.onClick)}
            sx={{display:'flex',justifyContent:'space-between'}}>
                <span style={{margin:'0 7px',fontSize:'0.8rem'}}>

                    {ele.name}
                </span>
                {ele.icon}

            </MenuItem>
            )
    }
  </Menu>

  );
}
 )